import Vue from "vue";

export const collapseChildCSSReactive = Vue.observable({ value: [] });

export default {
  get() {
    return collapseChildCSSReactive.value;
  },
  set(active) {
    collapseChildCSSReactive.value = active;
  },
};
